import React from 'react'
import './boxanime.css'
const Boxanime = () => {
  return (
    <div>
      <div class="container">
        {/* <hr className='phoneline'/>
        <div class="bulb">
          <div class="bulb__bg"></div>
          <div class="bulb__wire"></div>
          <div class="bulb__protector"></div>
          <div class="bulb__light"></div>
          <div class="light"></div>
        </div> */}
        <div class="box">
          <h1 className='pu'>PushTechn</h1>
          <p>We’ll be a sensation for your next renovation </p>
        
        </div>
      </div>
    </div>
  )
}

export default Boxanime
